import React from 'react';

interface CircularProgressProps {
    size?: number;         // diameter in pixels
    strokeWidth?: number;  // circle stroke width
    percentage: number;    // 0–100
}

const CircularProgress: React.FC<CircularProgressProps> = ({
    size = 55,
    strokeWidth = 8,
    percentage
}) => {
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (percentage / 100) * circumference;

    return (
        <div className="d-flex justify-content-center align-items-center" style={{ width: size, height: size }}>
            <svg width={size} height={size}>
                {/* Background circle */}
                <circle
                    stroke="#e9ecef"
                    fill="none"
                    strokeWidth={strokeWidth}
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                />
                {/* Progress circle */}
                <circle
                    stroke="#007AFF" // Bootstrap primary
                    fill="none"
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    style={{
                        transition: 'stroke-dashoffset 0.35s ease',
                        transform: 'rotate(-90deg)',
                        transformOrigin: '50% 50%'
                    }}
                />
                {/* Centered percentage text */}
                <text
                    x="50%"
                    y="50%"
                    dominantBaseline="middle"
                    textAnchor="middle"
                    fontSize="12"
                    fontWeight={600}
                    fill="#FFFFFF" // Bootstrap text-dark
                >
                    {Math.round(percentage)}%
                </text>
            </svg>
        </div>
    );
};

export default CircularProgress;